module.exports = __webpack_public_path__ + "img/stage-first-contact.33222a07.png";